/// <reference path="../../../components/controls/presets/presets-list.ts" />

module Meevo.Plugins.Client {
    "use strict";
    import IClientPackage = Meevo.Model.IClientPackage;
    import IClientPackageService = Meevo.Model.IClientPackageService;
    import IClientPackageTransaction = Meevo.Model.IClientPackageTransaction;
    import SalesTypeEnum = Meevo.Model.SalesTypeEnum;
    import IDataMaintenanceInfiniteList = Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
    import Location = Meevo.Model.Location;
    import NounEnum = Meevo.Model.NounEnum;
    import VerbEnum = Meevo.Model.VerbEnum;
    import SortDirection = Meevo.Model.SortDirection;
    import DiscountTypeEnum = Meevo.Model.DiscountTypeEnum;
    import IClientDiscountHistory = Meevo.Model.IClientDiscountHistory;
    import SaleStateEnum = Meevo.Model.SaleStateEnum;
    import BusinessInfoDataService = Meevo.Components.Common.BusinessInfoDataService;
    import PresetStatus = Meevo.Components.Controls.PresetStatus;
    import SaleTypeFilterEnum = Meevo.Model.SaleTypeFilterEnum;


    export class HistorySection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Client> {

        public historyTransaction: IDataMaintenanceInfiniteList;
        public historyDiscount: IDataMaintenanceInfiniteList;
        public customButtonsSet: Array<Meevo.Components.Controls.IMaintenanceFormCustomButton>;
        private securityKeys = Meevo.Components.Common.SecurityKeys;
        public arrayOfAvailableForUseWhenExpiredRequests: Array<any>;
        public historyFilter: string;
        public totalServiceVisits?: number;
        public extraItem: any = null;
        public isFilterExpanded: boolean = false;
        public activityAttribute: { topIndex: number } =({ topIndex: 0 });;
        public topIndex: number = 0;

        public request: ITransactionHistoryRequest = {
            itemsPerPage: 51,
            sortDirection: SortDirection.Descending,
            includeAssociatedSales: true,
            criteria: {
                isGlobal: true,
                filterLastTwoYears: false,
                endDate: moment().endOf("day").toDate(),
                startDate: moment().startOf("day").subtract("years", 1).toDate()
            }
        };
        public locations: Array<Location>;
        public itemTypeDisplay = {
            [SalesTypeEnum.Service]: 'S',
            [SalesTypeEnum.ServiceCancellationFee]: 'S',
            [SalesTypeEnum.ServiceNoShowFee]: 'S',
            [SalesTypeEnum.Product]: 'P',
            [SalesTypeEnum.GiftCard]: 'GC',
            [SalesTypeEnum.PromoGiftCard]: 'GC',
            [SalesTypeEnum.Package]: 'PKG',
            [SalesTypeEnum.Membership]: 'MEM',
            [SalesTypeEnum.MembershipPayment]: 'EFT',
            [SalesTypeEnum.MembershipRenewal]: 'EFT',
            [SalesTypeEnum.MembershipWaive]: 'EFT',
            [SalesTypeEnum.ClientAccountCredit]: 'A',
            [SalesTypeEnum.BulkGiftCard]: 'MGC',
            [SalesTypeEnum.PaymentPlanPayment]: 'PPP',
            [SalesTypeEnum.PaymentPlanPaymentEFT]: 'PPP',
            [SalesTypeEnum.PaymentPlanReduction]: 'PPR',
            [SaleTypeFilterEnum.Service]: 'S',
            [SaleTypeFilterEnum.Product]: 'P',
            [SaleTypeFilterEnum.GiftCard]: 'GC',
            [SaleTypeFilterEnum.Package]: 'PKG',
            [SaleTypeFilterEnum.Membership]: 'MEM',
            [SaleTypeFilterEnum.ClientAccountCredit]: 'A',
            [SaleTypeFilterEnum.ServicesOnly]: 'SO',
            [SaleTypeFilterEnum.ProductsOnly]: 'PO'
        };
        public historyItemTypeDisplay = {
            [SalesTypeEnum.Service]: 'LABEL_SERVICE',
            [SalesTypeEnum.ServiceCancellationFee]: 'LABEL_SERVICE',
            [SalesTypeEnum.ServiceNoShowFee]: 'LABEL_SERVICE',
            [SalesTypeEnum.Product]: 'LABEL_PRODUCT',
            [SalesTypeEnum.GiftCard]: 'LABEL_GIFT_CARD',
            [SalesTypeEnum.ReloadGiftCard]: 'LABEL_GIFT_CARD',
            [SalesTypeEnum.PromoGiftCard]: 'LABEL_GIFT_CARD',
            [SalesTypeEnum.Package]: 'LABEL_PACKAGE',
            [SalesTypeEnum.PackageTransfer]: 'LABEL_TRANSFER',
            [SalesTypeEnum.Membership]: 'LABEL_MEMBERSHIP',
            [SalesTypeEnum.MembershipPayment]: 'LABEL_MEMBERSHIP_PAYMENT',
            [SalesTypeEnum.MembershipRenewal]: 'LABEL_MEMBERSHIP_RENEWAL',
            [SalesTypeEnum.MembershipWaive]: 'LABEL_MEMBERSHIP_WAIVE',
            [SalesTypeEnum.PackageRefund]: 'LABEL_PACKAGE',
            [SalesTypeEnum.PackageServiceSwapFee]: 'LABEL_SERVICE_SWAP',
            [SalesTypeEnum.EgiftProcessingFee]: 'LABEL_EGIFT_PROCESSING_FEE',
            [SalesTypeEnum.EgiftShippingFee]: 'LABEL_EGIFT_SHIPPING_FEE',
            [SalesTypeEnum.ClientAccountCredit]: 'LABEL_ACCOUNT',
            [SalesTypeEnum.ClientAccountPayment]: 'LABEL_ACCOUNT_PAYMENT',
            [SalesTypeEnum.BulkGiftCard]: 'LABEL_SALESTYPE_MULTI_GIFT_CARD',
            [SalesTypeEnum.PaymentPlanPayment]: 'LABEL_SALESTYPE_PAYMENT_PLAN_PAYMENT',
            [SalesTypeEnum.PaymentPlanPaymentEFT]: 'LABEL_SALESTYPE_PAYMENT_PLAN_PAYMENT_EFT',
            [SalesTypeEnum.PaymentPlanReduction]: 'LABEL_SALESTYPE_PAYMENT_PLAN_REDUCTION',
            [SalesTypeEnum.AssociatedClient]: 'LABEL_SALESTYPE_TIP_ONLY'
        };

        public discountTypeDisplay = {
            [DiscountTypeEnum.SpecialPrice]: 'LABEL_SPECIAL_PRICE',
            [DiscountTypeEnum.AmountOff]: 'LABEL_AMOUNT_OFF',
            [DiscountTypeEnum.PercentOff]: 'LABEL_PERCENT_OFF',
            [DiscountTypeEnum.BuyGet]: 'LABEL_BUY_ONE_GET_ONE'
        };
        public itemTypes = [
            {
                saleTypeFilterEnum: SaleTypeFilterEnum.Service,
                identifier: this.itemTypeDisplay[SaleTypeFilterEnum.Service],
                label: 'SERVICES'
            },
            {
                saleTypeFilterEnum: SaleTypeFilterEnum.ServicesOnly,
                identifier: this.itemTypeDisplay[SaleTypeFilterEnum.ServicesOnly],
                label: 'HEADER_SERVICES_ONLY'
            },
            {
                saleTypeFilterEnum: SaleTypeFilterEnum.Product,
                identifier: this.itemTypeDisplay[SaleTypeFilterEnum.Product],
                label: 'HEADER_PRODUCTS'
            },
            {
                saleTypeFilterEnum: SaleTypeFilterEnum.ProductsOnly,
                identifier: this.itemTypeDisplay[SaleTypeFilterEnum.ProductsOnly],
                label: 'HEADER_PRODUCTS_ONLY'
            },
            {
                saleTypeFilterEnum: SaleTypeFilterEnum.GiftCard,
                identifier: this.itemTypeDisplay[SaleTypeFilterEnum.GiftCard],
                label: 'LABEL_GIFT_CARDS'
            },
            {
                saleTypeFilterEnum: SaleTypeFilterEnum.Package,
                identifier: this.itemTypeDisplay[SaleTypeFilterEnum.Package],
                label: 'LABEL_PACKAGES'
            },
            {
                saleTypeFilterEnum: SaleTypeFilterEnum.Membership,
                identifier: this.itemTypeDisplay[SaleTypeFilterEnum.Membership],
                label: 'HEADER_MEMBERSHIPS'
            },
            {
                saleTypeFilterEnum: SaleTypeFilterEnum.ClientAccountCredit,
                identifier: this.itemTypeDisplay[SaleTypeFilterEnum.ClientAccountCredit],
                label: 'HEADER_ACCOUNTS'
            }
        ];

        public historyTypes:any[] = [
            {
                historyTypeEnum: ClientHistoryType.AppointmentHistory,
                label: 'SECTION_CLIENT_HISTORY',
                security: this.securityKeys.DATA_CLIENT_ACTION_APPOINTMENTHISTORY// + Meevo.Components.Common.SecurityParts.KEY_PART_READ
            },
            {
                historyTypeEnum: ClientHistoryType.TransactionHistory,
                label: 'SECTION_CLIENT_TRANSACTION_HISTORY',
                security: this.securityKeys.DATA_CLIENT_ACTION_TRANSACTIONHISTORY// + Meevo.Components.Common.SecurityParts.KEY_PART_READ
            },
            {
                historyTypeEnum: ClientHistoryType.PackageHistory,
                label: 'LABEL_PACKAGE_HISTORY',
                security: this.securityKeys.DATA_CLIENT_TAB_PACKAGES + Meevo.Components.Common.SecurityParts.KEY_PART_READ
            },
            {
                historyTypeEnum: ClientHistoryType.GiftCardHistory,
                label: 'SECTION_CLIENT_GIFTCARD_HISTORY',
                security: this.securityKeys.DATA_CLIENT_TAB_GIFTCARDHISTORY + Meevo.Components.Common.SecurityParts.KEY_PART_READ
            },
            {
                historyTypeEnum: ClientHistoryType.AccountActivity,
                label: 'LABEL_ACCOUNT_ACTIVITY',
                security: this.securityKeys.DATA_CLIENT_ACTION_ACCOUNTACTIVITY
            }
        ]

        public currentDateTime: Date = new Date(moment().startOf('day').toString());

        public firstVisitDate: any;
        public lastVisitDate: any;
        public hideLocationInfoOnVisit: boolean = false;
        public packagesFilter: PackageType = PackageType.Active;
        private _packagesList: Array<IClientPackage> = [];
        private _isGlobal: boolean;
        public hideMobileFilters: boolean = false;
        private packagesCount: number;
        private packagesRemainingCount: number = 0;

        public packageTypeList = [
            { value: PackageType.All, label: 'LABEL_SHOW_ALL' },
            { value: PackageType.Active, label: 'LABEL_ACTIVE' },
            { value: PackageType.ExpiredWithBalance, label: 'LABEL_EXIPRED_WITH_BALANCE' },
            { value: PackageType.Expirednobalance, label: 'LABEL_EXPIRED_NO_BALANCE' },
            { value: PackageType.Membership, label: 'LABEL_MEMBERSHIP_PACKAGES' },
            { value: PackageType.NoBalance, label: 'LABEL_NO_BALANCE' },
            { value: PackageType.SplitMerge, label: 'HEADER_SPLIT_MERGE' }
           
        ];

        get isGlobal(): boolean {
            return this._isGlobal;
        }
        set isGlobal(value: boolean) {
            this._isGlobal = value;
        }

        expandPackageCallback(pkg) {
            if (pkg.transactions == null) {
                let criteria: Object = { pageNumber: 0, ItemsPerPage: 1000, isGlobal: this.isGlobal };

                this.dataService
                    .getListPaged(`ClientPackage/${pkg.clientPackage_TId}/Transaction`, criteria)
                    .then((response: any) => {
                        pkg.transactions = _.chain(response)
                            .groupBy((item) => { return item.transactionId.toString() + item.itemId.toString() })
                            .each((grp) => { if (grp[0].itemType != 2) { grp[0].quantity = grp.length; } })
                            .map((kvp) => kvp[0])
                            .value();
                        pkg.hasTransferToName = response.filter(row => typeof row.transferredToClientFirstName === 'string').length > 0;
                    });
            }
        }

        get packagesList(): Array<IClientPackage> {
            return this._packagesList;
        }
        /**
         * Updating packages list with formatted dates and packages transactions
         * */
        set packagesList(list: Array<IClientPackage>) {
            this._packagesList = list;
        }
        public selectedTab: TabViewEnum;
        public currentlySelectedTab: ClientHistoryType;
        public transactionHistSectionEndpoint = "grouptransactionHistory";
        public discountHistSectionEndpoint = "discountHistory";
        public importedHistSectionEndpoint = "importedTransactionHistory";
        public hideLocations: boolean = false;
        public transactionHistory = {};
        public discountHistory = {};
        public importedHistory = {};
        public currentHistoryPage: number = 0;
        public next50Exist: boolean = false;
        public transactionsScrollTopElement: number;
        public activityScrollTopElement: number;
        public viewPrivateService: boolean = false;
        public viewGlobalFilter: boolean = false;
        public presetList = [
            {name: 'LABEL_CUSTOM', status: PresetStatus.Custom},
            {name: 'LABEL_TODAY', status: PresetStatus.Today},
            {name: 'LABEL_YESTERDAY', status: PresetStatus.Yesterday},
            {name: 'LABEL_TOMORROW', status: PresetStatus.Tomorrow},
            {name: 'LABEL_THIS_WEEK', status: PresetStatus.ThisWeek},
            {name: 'LABEL_LAST_SEVEN_DAYS', status: PresetStatus.LastSevenDays},
            {name: 'LABEL_LAST_WEEK', status: PresetStatus.LastWeek},
            {name: 'LABEL_NEXT_WEEK', status: PresetStatus.NextWeek},
            {name: 'LABEL_PREVIOUS_TWO_WEEKS', status: PresetStatus.PreviousTwoWeeks},
            {name: 'LABEL_THIS_MONTH', status: PresetStatus.ThisMonth},
            {name: 'LABEL_LAST_THIRTY_DAYS', status: PresetStatus.LastThirtyDays},
            {name: 'LABEL_LAST_MONTH', status: PresetStatus.LastMonth},
            {name: 'LABEL_NEXT_MONTH', status: PresetStatus.NextMonth},
            {name: 'LABEL_THIS_QUARTER', status: PresetStatus.ThisQuarter},
            {name: 'LABEL_LAST_QUARTER', status: PresetStatus.LastQuarter},
            {name: 'LABEL_NEXT_QUARTER', status: PresetStatus.NextQuarter},
            {name: 'LABEL_THIS_YEAR', status: PresetStatus.ThisYear},
            {name: 'LABEL_LAST_TWELVE_MONTHS', status: PresetStatus.LastTwelveMonthsIncludingToday},
            {name: 'LABEL_LAST_YEAR', status: PresetStatus.LastYear},
            {name: 'LABEL_NEXT_YEAR', status: PresetStatus.NextYear},
            {name: 'LABEL_YEAR_TO_DATE', status: PresetStatus.YearToDate}
        ];

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            protected $cookies: angular.cookies.ICookiesService,
            protected printService: Meevo.Components.Common.IPrintService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected recentClientsService: Meevo.Plugins.Client.RecentClientsService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $q: angular.IQService,
            protected $scope: angular.IScope,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            private context: Meevo.Plugins.Client.ClientContext,
            protected $filter: angular.IFilterService,
            protected $sce: ng.ISCEService,
            sectionSecurityKey?: string,
            private $translate?: angular.translate.ITranslateService,
            protected securityService?: Meevo.Components.Common.ISecurityService,

        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService,
                identityService, noun, appSettings, sectionSecurityKey);
            this.noun = noun;
            if (_.find(this.historyTypes, function (item) { return (securityService.checkCachedSecurityKey(item.security) == Model.SecurityAccessEnum.Grant && item.historyTypeEnum == ClientHistoryType.TransactionHistory); })){
                this.currentlySelectedTab = ClientHistoryType.TransactionHistory;
            }
           else {
               var dItem = _.find(this.historyTypes, function (item) { return (securityService.checkCachedSecurityKey(item.security) == Model.SecurityAccessEnum.Grant); });
                if (dItem)
                    this.currentlySelectedTab = dItem.historyTypeEnum
            }

            this.arrayOfAvailableForUseWhenExpiredRequests = [];
            this.viewPrivateService = this.securityService.checkCachedSecurityKey(this.securityKeys.DATA_CLIENT_ACTION_VIEWPRIVATESERVICE) == Model.SecurityAccessEnum.Grant;
            this.viewGlobalFilter = this.securityService.checkCachedSecurityKey(this.securityKeys.DATA_CLIENT_TAB_HISTORY_FIELD_ISGLOBAL + SecurityParts.KEY_PART_READ) == Model.SecurityAccessEnum.Grant;

            this.customButtonsSet = [
                {
                    text: 'LABEL_BACK',
                    clickHandler: () => {
                        this.hideMobileFilters = false;
                    },
                    classNames: 'meevo-button client-transaction-nav-button',
                    disableRules: () => false,
                    visibilityRules: () => this.hideMobileFilters && this.$scope.isMobileDevice,
                    securityRules: null,
                    position: 'left'
                },
                {
                    text: 'LABEL_CLIENT_BACK_TO_TOP',
                    clickHandler: () => {
                        this.scrollToPosition(false);
                    },
                    classNames: 'meevo-button client-transaction-nav-button',
                    disableRules: () => false,
                    visibilityRules: () => (this.hideMobileFilters && this.$scope.isMobileDevice) || !this.$scope.isMobileDevice,
                    securityRules: null,//this.securityKeys.DATA_CLIENT_TAB_MAIN_PURGE + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    position: 'left'
                },
                {
                    text: 'LABEL_CLIENT_LOAD_MORE',
                    clickHandler: () => {
                        this.getMoreTransactions(this.request);
                    },
                    classNames: 'meevo-button client-transaction-nav-button',
                    disableRules: () => false,
                    visibilityRules: () => this.next50Exist,
                    securityRules: null,//this.securityKeys.DATA_CLIENT_TAB_MAIN_PURGE + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    position: 'right'
                },
                {
                    text: 'LABEL_EDIT',
                    clickHandler: () => {
                        this.mode = Meevo.Model.MaintenanceFormState.Editing;
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => {
                        return false;
                        //return (
                        //    (this.mode == Meevo.Model.MaintenanceFormState.Readonly && this.currentlySelectedTab == ClientHistoryType.PackageHistory && !this.$scope.isMobileDevice)
                        //    || (this.mode == Meevo.Model.MaintenanceFormState.Readonly && this.currentlySelectedTab == ClientHistoryType.PackageHistory && this.hideMobileFilters && this.$scope.isMobileDevice )
                        //)
                    },
                    securityRules: this.securityKeys.DATA_CLIENT_ACTION_HISTORY_EDITPACKAGEHISTORY + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    position: 'right'
                },
                {
                    text: 'LABEL_SAVE',
                    clickHandler: () => {
                        this.updateClientPackage();
                        this.mode = Meevo.Model.MaintenanceFormState.Readonly;
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => {
                        return (
                            (this.mode == Meevo.Model.MaintenanceFormState.Editing && this.currentlySelectedTab == ClientHistoryType.PackageHistory && !this.$scope.isMobileDevice)
                            || (this.mode == Meevo.Model.MaintenanceFormState.Editing && this.currentlySelectedTab == ClientHistoryType.PackageHistory && this.hideMobileFilters && this.$scope.isMobileDevice)
                        )
                    },
                    securityRules: null,//this.securityKeys.DATA_CLIENT_TAB_MAIN_PURGE + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    position: 'right'
                },
                {
                    text: 'LABEL_CANCEL',
                    clickHandler: () => {
                        this.mode = Meevo.Model.MaintenanceFormState.Readonly;
                        for (var i = 0; i < this.arrayOfAvailableForUseWhenExpiredRequests.length; i++) {
                            for (var j = 0; j < this.packagesList.length; j++) {
                                // Maybe say that there was an error updating the package
                                if (this.arrayOfAvailableForUseWhenExpiredRequests[i].id == this.packagesList[j].clientPackage_TId) {
                                    this.packagesList[j].isAvailableForUseWhenExpired = !this.arrayOfAvailableForUseWhenExpiredRequests[i].isAvailableForUseWhenExpired;
                                }
                            }
                        }

                        this.arrayOfAvailableForUseWhenExpiredRequests = [];
                    },
                    classNames: 'meevo-button',
                    disableRules: () => false,
                    visibilityRules: () => {
                        return (
                            (this.mode == Meevo.Model.MaintenanceFormState.Editing && this.currentlySelectedTab == ClientHistoryType.PackageHistory && !this.$scope.isMobileDevice)
                            || (this.mode == Meevo.Model.MaintenanceFormState.Editing && this.currentlySelectedTab == ClientHistoryType.PackageHistory && this.hideMobileFilters && this.$scope.isMobileDevice)
                        )
                    },
                    securityRules: null,//this.securityKeys.DATA_CLIENT_TAB_MAIN_PURGE + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    position: 'right'
                }
            ];

            this.isFilterExpanded = ((!this.hideMobileFilters && this.$scope.isMobileDevice) || !this.$scope.isMobileDevice);

        }

        public packageContainsMoreThanOneItemRemaining(clientPackage: any): boolean {
            return this.packageContainsMoreThanOneServiceRemaining(clientPackage) ||
                this.packageContainsMoreThanOneProductUnitRemaining(clientPackage) ||
                this.packageContainsMoreThanOneProductRemaining(clientPackage);
        }

        packageContainsMoreThanOneServiceRemaining(clientPackage): boolean {
            const clientPackageServices = clientPackage.clientPackageServices;

            if (clientPackageServices == undefined)
                return false;

            var hasRemainingServices = false;
            for (var i = 0; i < clientPackageServices.length; i++) {
                if (clientPackageServices[i].quantityRemaining > 0) {
                    hasRemainingServices = true;
                    break;
                }
            }
            return hasRemainingServices;
        }

        packageContainsMoreThanOneProductRemaining(clientPackage): boolean {
            const clientPackageProducts = clientPackage.clientPackageProducts;

            if (clientPackageProducts == undefined)
                return false;

            var hasRemainingProducts = false;
            for (var i = 0; i < clientPackageProducts.length; i++) {
                if (clientPackageProducts[i].itemType == Model.PackageItemTypeEnum.Product && clientPackageProducts[i].quantityRemaining > 0) {
                    hasRemainingProducts = true;
                    break;
                }
            }
            return hasRemainingProducts;
        }

        packageContainsMoreThanOneProductUnitRemaining(clientPackage): boolean {
            const clientPackageProductUsages = clientPackage.clientPackageProductUsages;

            if (clientPackageProductUsages == undefined)
                return false;

            var hasRemainingProductUsages = false;
            for (var i = 0; i < clientPackageProductUsages.length; i++) {
                if (clientPackageProductUsages[i].itemType == Model.PackageItemTypeEnum.ProductUnit && clientPackageProductUsages[i].quantityRemaining > 0) {
                    hasRemainingProductUsages = true;
                    break;
                }
            }
            return hasRemainingProductUsages;
        }

        public updateClientPackage(): any {

            if (this.arrayOfAvailableForUseWhenExpiredRequests.length > 0) {
                this.dataService.customMethodData(this.appSettings.API_ROOT + "/ClientPackage/AvailableForUseWhenExpired", "POST", { "ClientPackageAvailableForUsePosts" : this.arrayOfAvailableForUseWhenExpiredRequests })
                    .then((response: any) => {
                        for (var i = 0; i < response.data.length; i++) {
                            if (!response.data[i].updatedSuccessfully) {
                                for (var j = 0; j < this.packagesList.length; j++) {
                                    // Maybe say that there was an error updating the package

                                }
                            }
                        }
                        this.arrayOfAvailableForUseWhenExpiredRequests = [];
                        this.getPackages();
                    });
            }
        }

        public isFutureDate(date: string | Date): boolean {
            return moment(date).isAfter(moment())
        }

        public isSingleLocation(): boolean {
            if (Model.Guard.isSomething(this.identityService.current().isSingleLocation))
                return this.identityService.current().isSingleLocation;
            else
                return false;
        }

        activate(subSectionContentKey?: string) {
            super.activate(subSectionContentKey);
            this.setSelectedHistoryTab(subSectionContentKey);
        }

        public isSubSectionSelected(subSectionContentKey?: string): boolean {
            return (
                (this.currentlySelectedTab == ClientHistoryType.GiftCardHistory && subSectionContentKey == "GIFTCARD_HISTORY") ||
                (this.currentlySelectedTab == ClientHistoryType.TransactionHistory && subSectionContentKey == "TRANSACTION_HISTORY") ||
                (this.currentlySelectedTab == ClientHistoryType.PackageHistory && subSectionContentKey == "PACKAGE_HISTORY") ||
                (this.currentlySelectedTab == ClientHistoryType.AppointmentHistory && subSectionContentKey == "APPOINTMENT_HISTORY") ||
                (this.currentlySelectedTab == ClientHistoryType.AccountActivity && subSectionContentKey == "ACCOUNT_HISTORY")
            );
        }

        selected(subSectionContentKey?: string): void {
            super.selected(subSectionContentKey);
            this.setSelectedHistoryTab(subSectionContentKey);
            this.selectHistoryTab();
        }

        addOrRemoveAvailableForUseWhenExpiredRequest(id, isAvailableForUseWhenExpired, packageLocationId, entityVersion) {
            if (!this.isSectionEditing())
                return;

            if (this.identityService.locationId != packageLocationId) {
                this.modalService.alert("MESSAGE_CANNOT_EDIT_DIFFERENT_LOCATION_PACKAGE_HISTORY");
                return;
            }

            var doesThisIdAlreadyExistInTheArray = false;

            for (var i = 0; i < this.arrayOfAvailableForUseWhenExpiredRequests.length; i++) {
                if (this.arrayOfAvailableForUseWhenExpiredRequests[i].id == id) {
                    doesThisIdAlreadyExistInTheArray = true;

                    // clear the date on the package
                    for (var j = 0; j < this.packagesList.length; j++) {
                        if (this.packagesList[j].clientPackage_TId == this.arrayOfAvailableForUseWhenExpiredRequests[i].id) {
                            this.packagesList[j].availableForUseExpireDate = null;
                            break;
                        }
                    }

                    this.arrayOfAvailableForUseWhenExpiredRequests.splice(i, 1);
                    break;
                }
            }

            if (!doesThisIdAlreadyExistInTheArray) {
                var request = {
                    "id": id,
                    "isAvailableForUseWhenExpired": isAvailableForUseWhenExpired,
                    "entityVersion": entityVersion
                };
                this.arrayOfAvailableForUseWhenExpiredRequests.push(request);
            }
        }

        addAvailableForUseExpireDate(pkg: IClientPackage) {
            if (!this.isSectionEditing() && !pkg.isAvailableForUseWhenExpired)
                return;

            if (this.identityService.locationId != pkg.locationId) {
                this.modalService.alert("MESSAGE_CANNOT_EDIT_DIFFERENT_LOCATION_PACKAGE_HISTORY");
                return;
            }

            var req: any = _.findWhere(this.arrayOfAvailableForUseWhenExpiredRequests, { id: pkg.clientPackage_TId });
            if (req) {
                req.availableForUseExpireDate = pkg.availableForUseExpireDate;
            }
            else {
                var request = {
                    "id": pkg.clientPackage_TId,
                    "isAvailableForUseWhenExpired": pkg.isAvailableForUseWhenExpired,
                    "entityVersion": pkg.entityVersion,
                    "availableForUseExpireDate": pkg.availableForUseExpireDate
                };
                this.arrayOfAvailableForUseWhenExpiredRequests.push(request);
            }
        }

        isSectionEditing(): boolean {
            return this.mode === Meevo.Model.MaintenanceFormState.Editing;
        }

        setSelectedHistoryTab(subSectionContentKey?: string) {
            this.selectedTransHist();
            if (subSectionContentKey) {
                if (subSectionContentKey == "GIFTCARD_HISTORY" && this.securityService.checkCachedSecurityKey(this.securityKeys.DATA_CLIENT_TAB_GIFTCARDHISTORY + Meevo.Components.Common.SecurityParts.KEY_PART_READ) == Model.SecurityAccessEnum.Grant) {
                    this.currentlySelectedTab = ClientHistoryType.GiftCardHistory;
                }
                else if (subSectionContentKey == "TRANSACTION_HISTORY" && this.securityService.checkCachedSecurityKey(this.securityKeys.DATA_CLIENT_ACTION_TRANSACTIONHISTORY) == Model.SecurityAccessEnum.Grant) {
                    this.currentlySelectedTab = ClientHistoryType.TransactionHistory;
                }
                else if (subSectionContentKey == "PACKAGE_HISTORY" && this.securityService.checkCachedSecurityKey(this.securityKeys.DATA_CLIENT_TAB_PACKAGES + Meevo.Components.Common.SecurityParts.KEY_PART_READ) == Model.SecurityAccessEnum.Grant) {
                    this.currentlySelectedTab = ClientHistoryType.PackageHistory;
                }
                else if (subSectionContentKey == "APPOINTMENT_HISTORY" && this.securityService.checkCachedSecurityKey(this.securityKeys.DATA_CLIENT_ACTION_APPOINTMENTHISTORY) == Model.SecurityAccessEnum.Grant) {
                    this.currentlySelectedTab = ClientHistoryType.AppointmentHistory;
                }
                else if (subSectionContentKey == "ACCOUNT_HISTORY" && this.securityService.checkCachedSecurityKey(this.securityKeys.DATA_CLIENT_ACTION_ACCOUNTACTIVITY) == Model.SecurityAccessEnum.Grant) {
                    this.currentlySelectedTab = ClientHistoryType.AccountActivity;
                }               
            }
        }

        public selectHistoryTab() {
            this.disableCrud = null;
            var auditNoun = Meevo.Model.NounEnum.ClientAppointmentHistory;
            if (this.currentlySelectedTab == ClientHistoryType.GiftCardHistory) {
                auditNoun = Meevo.Model.NounEnum.ClientGiftCardHistory;
            } else if (this.currentlySelectedTab == ClientHistoryType.TransactionHistory) {
                auditNoun = Meevo.Model.NounEnum.ClientTransactionHistory;
                this.selectedTransHist();
            } else if (this.currentlySelectedTab == ClientHistoryType.PackageHistory) {
                auditNoun = Meevo.Model.NounEnum.ClientPackageHistory;
                this.getPackages();
                this.getLocations();
                this.disableCrud = true;
            } else if (this.currentlySelectedTab == ClientHistoryType.AccountActivity) {
                auditNoun = Meevo.Model.NounEnum.ClientAccountHistory;
                this.next50Exist = false;
            }
            // Track history tab selection
            this.usageTrackingLog(auditNoun, Meevo.Model.VerbEnum.Selected);
           // console.log('filterDescription1', this.filterDescription);
            this.filterDescription.length = 0;
                this.filterDescription.push(...this.getFilterDescription());
            }
            
        public getFirstAndLastVisitDate(): ng.IPromise<any> {
            this.firstVisitDate = null;
            this.lastVisitDate = null;

            return this.dataService.customMethodData(`api/client/${this.parentItemId}/firstLastVisit`, "POST", {
                locationId: (this.request.criteria.locationId) ? this.request.criteria.locationId : 0
            }).then((response) => {
                if (response.data.length > 0) {
                    this.firstVisitDate = response.data[0];
                    if (response.data.length > 1) {
                        this.lastVisitDate = response.data[1];
                    }
                    else {
                        this.lastVisitDate = this.firstVisitDate;
                    }

                    if (!this.firstVisitDate["lastVisitDate"] && this.firstVisitDate["firstVisitDate"]) {
                        this.firstVisitDate["lastVisitDate"] = this.firstVisitDate["firstVisitDate"];
                    }
                    if (!this.firstVisitDate["firstVisitDate"] && this.firstVisitDate["lastVisitDate"]) {
                        this.firstVisitDate["firstVisitDate"] = this.firstVisitDate["lastVisitDate"];
                    }
                }
                else {
                    var historyCriteria = {
                        itemsPerPage: 1,
                        sortDirection: SortDirection.Descending,
                        includeAssociatedSales: true,
                        criteria: {
                            isGlobal: true,
                            filterLastTwoYears: false,
                            saleTypeFilterEnum: this.request.criteria.saleTypeFilterEnum ? this.request.criteria.saleTypeFilterEnum : SaleTypeFilterEnum.Service,
                        }
                    };

                    return this.dataService.customMethodData(`api/client/${this.parentItemId}/${this.transactionHistSectionEndpoint}/List/`, "POST", historyCriteria).then((data) => {
                        if (data.data && data.data.length > 0) {
                            let sale = data.data[0];
                            this.lastVisitDate = this.firstVisitDate = {
                                lastVisitDate: sale.saleDate,
                                firstVisitDate: sale.saleDate,
                                locationId: sale.locationId,
                                storeName: sale.storeName
                            };
                        }
                    });
                }
            });
        }

        //////////////////////////////
        /*  start package history  */
        //////////////////////////////

        /**
         * Updating packages on tab selected
         * */
        public selectedApptHist(): void {
            this.getPackages();
        }

        /**
         * Getting packages from database according to selected filter
         * */
        public getPackages(): void {
            var iframe = document.getElementById("package-history-iframe-helper");

            if (iframe) {
                this.busyService.start();

                let url = `${this.appSettings.MEEVO_MODULES_URL}/client/${this.parentItemId}/package-history/${this.packagesFilter}`;
                if (this.request && this.request.criteria && this.request.criteria.locationId) {
                    url += `/${this.request.criteria.locationId}`;
                }

                iframe["src"] = this.$sce.trustAsResourceUrl(url);
            }
            else {
                window.setTimeout(() => this.getPackages(), 200);
            }

            this.filterDescription.length = 0;
            this.filterDescription.push(...this.getFilterDescription());
        }

        public isPackageExpired(pkg: IClientPackage): boolean {
            // set to 12AM on current date
            let currentDateTime: Date = new Date(moment().startOf('day').toString());
            return (currentDateTime > pkg.expireDate);
        }

        applyStateCriteria(criteria) {
            criteria.transitionStates = [
                Model.AppointStateEnum.Arrived,
                Model.AppointStateEnum.Booked,
                Model.AppointStateEnum.CheckedIn,
                Model.AppointStateEnum.Conflict, /* TODO: check if needed to be here! */
                Model.AppointStateEnum.NoShow,
                Model.AppointStateEnum.Pending,
                Model.AppointStateEnum.RunningLate,
                Model.AppointStateEnum.WalkInNoShow,
                Model.AppointStateEnum.WalkInPending,
                Model.AppointStateEnum.WalkInRescan,
                Model.AppointStateEnum.WalkOut
            ];
            criteria.finalStates = [];
            criteria.startDate = null;
            criteria.cancelledOrNoShowedOnly = false;
            switch (criteria.filter) {
                case ClientAppointmentHistoryFilterType.Future: // Future
                    criteria.finalStates.push(Model.AppointFinalStateEnum.CheckedOut);
                    criteria.finalStates.push(Model.AppointFinalStateEnum.None);
                    criteria.startDate = moment().startOf("day").toDate();
                    break;
                case ClientAppointmentHistoryFilterType.CheckedOut: // Checked-out
                    criteria.finalStates.push(Model.AppointFinalStateEnum.CheckedOut);
                    break;
                case ClientAppointmentHistoryFilterType.Cancelled: // Cancelled
                    criteria.finalStates.push(Model.AppointFinalStateEnum.Cancelled);
                    break;
                case ClientAppointmentHistoryFilterType.NoShow: // No-showed
                    criteria.transitionStates = [ Model.AppointStateEnum.NoShow ];
                    criteria.finalStates.push(Model.AppointFinalStateEnum.Cancelled);
                    criteria.finalStates.push(Model.AppointFinalStateEnum.CheckedOut);
                    criteria.finalStates.push(Model.AppointFinalStateEnum.None);
                    break;
                case ClientAppointmentHistoryFilterType.NoShowAndCancelled: // Cancelled or No-Showed
                    criteria.transitionStates = null;
                    criteria.finalStates = null;
                    criteria.cancelledOrNoShowedOnly = true;
                    break;
                default:
                    criteria.finalStates.push(Model.AppointFinalStateEnum.Cancelled);
                    criteria.finalStates.push(Model.AppointFinalStateEnum.CheckedOut);
                    criteria.finalStates.push(Model.AppointFinalStateEnum.None);
                    break;
            }
        }

        getLocations(): void {
            this.dataService.customMethodData('api/location/list', 'POST', {
                criteria: {
                    filterBySessionUser: true,
                    zipCode: '',
                    locationStatus: [30188, 30189, 30190, 30191], // Active, TemporarilyClosed, ClosingPlanned, Closed
                    subscriptionStatus: [1840, 1841, 1842, 1843, 1844, 1845, 30187, 30258] // Active, Frozen, Suspended, Cancelled, Terminated, Inactive, Pending, Upgrading
                },
                includeActive: true,
                includeDeleted: false,
                includeInactive: false,
                itemsPerPage: 100000,
                pageNumber: 0,
                sortBy: '',
                sortDirection: Meevo.Model.SortDirection.Ascending
            })
                .then((response) => {
                    let that = this;
                    var tempArray = angular.copy(response.data);
                    var index = _.findIndex(tempArray, function (item: any) { return item.id == that.identityService.locationId; });
                    var item = tempArray.splice(index, 1);

                    this.locations = [...item, ...tempArray];
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * get string enum value
         * @param {SalesTypeEnum} value
         * @returns {string}
         */
        getSalesType(transaction: any): string {
            if (transaction.isRefund && (transaction.saleTypeEnum === SalesTypeEnum.MembershipPayment || transaction.saleTypeEnum === SalesTypeEnum.MembershipPaymentEFT))
                return this.$translate.instant("LABEL_EFT_REFUND");
            else
                return (transaction.itemType == 2) ? this.$translate.instant("LABEL_PRODUCT_UNIT_REDEMPTION_TYPE") : SalesTypeEnum[transaction.saleTypeEnum];
        }

        /**
        * Open selected transaction in Transaction Editor
        * @param {string} transactionNumber
        */
        openTransactionEditorApptHist(transactionNumber: string): void {
            if (!transactionNumber) return;

            // Build params for loading transaction in editor
            let stateParams = {
                transactionId: transactionNumber,
                includeActive: true,
                includeCompleted: true,
                includeOnHold: false,
                includeRefunded: true,
                includeVoided: true
            };

            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: stateParams,
                securityKey: this.securityKeys.REGISTER_TRANSACTIONEDITOR + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
            });
        }
        //////////////////////////////
        /*  end package history  */
        //////////////////////////////

        ///////////////////////////////////////////
        /*  start transaction history section */
        ///////////////////////////////////////////

        selectedTransHist(): void {
            if (this.securityService.checkCachedSecurityKey(this.securityKeys.DATA_CLIENT_ACTION_TRANSACTIONHISTORY) == Model.SecurityAccessEnum.Grant) {
                super.selected();
                this.selectedTab = TabViewEnum.TransactionView;

                this.request.clientGlobalId = this.parentItemId;
                this.filter();

                this.busyService.start();
                this.getLocations();
                this.getFirstAndLastVisitDate();
            }
        }

        /**
         * Apply current filter
         */
        applyFilter(): void {
            this.extraItem = null;
            this.totalServiceVisits = null;
            this.hideLocationInfoOnVisit = (!!this.request.criteria.locationId || this.isSingleLocation());
            this.filter();
            this.getFirstAndLastVisitDate();
            this.usageTrackingLog(Meevo.Model.NounEnum.ClientTransactionHistory, Meevo.Model.VerbEnum.ApplyButtonClicked);

            if (!this.$scope.isMobileDevice || !this.hideMobileFilters) {
                this.isFilterExpanded = false;
            }
        }

        /**
         * Do filtering
         */
        filter(): void {
            let request: ITransactionHistoryRequest = angular.copy(this.request);
            let isShowTransaction = BusinessInfoDataService.businessInfoPreferences.clientsSettings.showTransactionHistoryForMultipleLocation;

            if (!this.request.criteria.locationId) {
                request.criteria.locationId = this.identityService.current().locationId;
                request.criteria.isGlobal = true;
            } else {
                request.criteria.isGlobal = false;
            }
            if (!isShowTransaction && this.currentlySelectedTab == ClientHistoryType.TransactionHistory) {
                this.hideLocations = true;
            }
            if (this.currentlySelectedTab == ClientHistoryType.AppointmentHistory) {
                this.applyStateCriteria(request.criteria);
            }

            this.getTransactions(request, false);

            this.filterDescription.length = 0
            this.filterDescription.push(...this.getFilterDescription());
        }

        /* Reset filter */
        resetFilter(): void {

            this.extraItem = null;
            this.request.criteria.locationId = null;

            // if on transactions filter, reset to defaults for Transaction History
            if (this.currentlySelectedTab === 2) {
                //this.selectedTab = TabViewEnum.TransactionView;
                this.request.criteria.saleTypeFilterEnum = null;
                this.request.criteria.startDate = moment().startOf("day").subtract("years", 1).toDate();
                this.request.criteria.endDate = moment().endOf("day").toDate();
                this.context.presetStatus = Components.Controls.PresetStatus.LastTwelveMonthsIncludingToday;
                this.context.selectedPreset = _.findWhere(this.presetList, { status: this.context.presetStatus });
                this.applyFilter();
            }
            // if on packages filter, reset to defaults for Package History
            if (this.currentlySelectedTab === 3) {
                this.packagesFilter = PackageType.All;
                this.getPackages();
            }

            this.filterDescription.length = 0
            this.filterDescription.push(...this.getFilterDescription());
        }

        /**
         * Open selected transaction in Transaction Editor
         * @param {string} transactionNumber
         * @param {number} locationId
         */
        openTransactionEditorTransHist(transactionNumber: string, locationId: number): void {
            if (!transactionNumber || transactionNumber === "N/A") return;

            if (locationId !== this.identityService.locationId) {
                this.modalService.alert("MESSAGE_TRANSACTION_AT_ANOTHER_LOCATION", Components.Modal.ModalTranslationModes.Translate);
                return;
            }

            // Build params for loading transaction in editor
            let stateParams = {
                transactionId: Number(transactionNumber),
                includeActive: true,
                includeCompleted: true,
                includeOnHold: false,
                includeRefunded: true,
                includeVoided: true
            };
            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: stateParams,
                securityKey: this.securityKeys.REGISTER_TRANSACTIONEDITOR + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
            });
        }

        openActivityLog(transItem: any) {

            const effectiveTransactionDate = transItem.dateUpdated ?
                transItem.dateUpdated :
                transItem.transactionDate;

            const filterParams: any = {
                auditActivity: Plugins.ActivityLog.CategorySearchEnum.All,
                client: null,
                employee: null,
                user: null,
                filter: null,
                keyword: null,
                isGlobal: false,
                maintenanceMode: false,
                purpose: null,
                wildcardType: null,
                startDate: moment(transItem.dateCreated).add(-2, 'minutes').toDate(),
                endDate: moment(effectiveTransactionDate).add(2, 'minutes').toDate(),
                timeType: Plugins.ActivityLog.TimeTypesEnum.Custom,
                postFilter: transItem.transactionNumber
            }

            const stateParams: any = {
                filterParams: filterParams,
                callbackState: this.appSettings.ROUTE_NAMES.client
            }

            this.$rootScope.$broadcast(Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.activityLog,
                stateParams: stateParams,
                securityKey: Meevo.Components.Common.SecurityKeys.MANAGEMENT_ACTIVITYLOG + Meevo.Components.Common.SecurityParts.KEY_PART_READ
            });
        }


        /**
         * Print receipt
         * item
         * {PrintTypeEnum} printType
         */
        print(item: any, printType: PrintTypeEnum): void {
            if (!item.transactionNumber || !item.transactionGuid) {
                return;
            }

            this.showGiftReceiptPreviewModal(item, printType).then(excludeSaleLineIds => {
                if (printType === PrintTypeEnum.GiftReceipt && !excludeSaleLineIds) {
                    return;
                }

                this.busyService.start();
                var showCopy = true;
                var receiptUrl: string = `/api/Sale/${item.transactionNumber}/${PrintTypeEnum[printType]}`;
                var method = 'GET'
                if (printType === PrintTypeEnum.InsuranceReceipt) {
                    receiptUrl += "/List";
                    showCopy = false;
                } 
                var options = {
                    url: receiptUrl,
                    method: method,
                    params: {
                        showCopy: showCopy,
                        locale: this.appSettings.APP_COUNTRYID,
                        timeFormat: this.appSettings.APP_TIME_FORMAT,
                    }
                };
    
                if(printType === PrintTypeEnum.GiftReceipt) {
                    method = 'POST';
                    (<any> options.params).excludeSaleLineIds = excludeSaleLineIds;
                }
    
                this.printService.printCustom(options).then((returnData) => {
                    return this.dataService.trackUsage(Meevo.Model.NounEnum.TransactionEditorPage, Meevo.Model.VerbEnum.PrintReceiptButtonClicked, null, item.transactionGuid);
                }).finally(() => {
                    this.busyService.stop();
                });
            });
        }

        showGiftReceiptPreviewModal(item, printType: PrintTypeEnum) {

            if (printType !== PrintTypeEnum.GiftReceipt) {
                return this.$q.resolve(null);
            }

            let modalOptions: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/register/modals/giftReceiptModal.template.html",
                controller: "meevo.plugins.register.GiftReceiptModal",
                controllerAs: "vm",
                bindToController: true,
                multiple: true,
                locals: {
                    transactionId: item.transactionNumber
                }
            }

            return this.modalService.showCustom(modalOptions);
        }

        /**
         * Email receipt
         * item
         * {PrintTypeEnum} printType
         */
        email(item: any, printType: PrintTypeEnum): ng.IPromise<any> {
            return this.dataService.customMethodData(`/api/client/${this.parentItemId}/Email`, "GET", null)
                .then((response) => {
                    const emailAddress = response.data.emailAddress;

                    this.showGiftReceiptPreviewModal(item, printType).then((excludeSaleLineIds: Number[]) => {
                        if (printType === PrintTypeEnum.GiftReceipt && !excludeSaleLineIds) {
                            return this.$q.resolve(null);
                        }

                        let options: Meevo.Components.Modal.IModalOptions = {
                            templateUrl: 'app/plugins/client/sectionViews/selectEmail.modal.html',
                            controller: 'meevo.plugins.client.SelectEmailController',
                            controllerAs: "vm",
                            bindToController: true,
                            escapeToClose: false,
                            clickOutsideToClose: false,
                            locals: {
                                email: emailAddress
                            }
                        }
    
                        return this.modalService.showCustom(options).then(selectedEmail => {
                            switch (printType) {
                                case PrintTypeEnum.Receipt:
                                    return this.receiptNotification(item, Meevo.Model.CommunicationTypeEnum.SaleCreated, selectedEmail, true);
                                case PrintTypeEnum.GiftReceipt:
                                    return this.receiptNotification(item, Meevo.Model.CommunicationTypeEnum.GiftReceiptCreated, selectedEmail, true, excludeSaleLineIds);
                                case PrintTypeEnum.InsuranceReceipt:
                                    return this.receiptNotification(item, Meevo.Model.CommunicationTypeEnum.InsuranceReceiptCreated, selectedEmail, false);
                            }
                        });
                    });
                });
        }

        // Sends email notifications based on types i.e. Sale Created ( receipt ) , Gift Receipt created ( gift receipt ), insurance receipt
        receiptNotification(transItem: any, type: Meevo.Model.CommunicationTypeEnum, selectedEmail: string, showCopy: boolean = false, excludeSaleLineIds?: Number[]) {
            let saleDate = moment(transItem.saleDate).format("YYYY-MM-DD").toString();
            let communicationType = type;
            let communicationMethod = Meevo.Model.CommunicationMethodEnum.Email;
            let saleid = parseInt(transItem.saleId);

            let data = {
                id: saleid,
                emailId: selectedEmail,
                saleId: saleid,
                saleDate: saleDate,
                communicationType: communicationType,
                communicationMethod: communicationMethod,
                clientId: null,
                showCopy: showCopy,
                locale: this.appSettings.APP_COUNTRYID,
                timeFormat: this.appSettings.APP_TIME_FORMAT,
                excludeSaleLineIds: excludeSaleLineIds
            }

            if (saleid) {
                let url = `/${this.appSettings.API_ROOT}/Sale/${saleid}/Notification`;
                this.dataService.customMethodData(url, "POST", data);
            }
        }

        /**
         * Track Usage
         * @param {NounEnum} nounEnum
         * @param {VerbEnum} verbEnum
         */
        usageTrackingLog(nounEnum: NounEnum, verbEnum: VerbEnum): void {
            let trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, null, this.parentItemId);

            this.trackingService.saveTrackingInfo(trackingItem);
        }

        get printTypeEnum(): any {
            return PrintTypeEnum;
        }

        get tabViewEnum(): any {
            return TabViewEnum;
        }

        get nounEnum(): any {
            return NounEnum;
        }

        get saleStateEnum(): any {
            return SaleStateEnum;
        }

        get discountTypeEnum(): any {
            return DiscountTypeEnum;
        }

        /**
        * Select tab
        * @param {TabViewEnum} tab
        */
        selectTab(tab: TabViewEnum, nounEnum: NounEnum): void {
            this.extraItem = null;
            this.selectedTab = tab;
            this.usageTrackingLog(nounEnum, VerbEnum.Viewed);
            this.filter();
        }

        fetchItemAtIndex = function (index) {
            let itemPage = {};
            let pageNumber = Math.floor(index / this.requestPage.itemsPerPage);
            let page = this.loadedPages[pageNumber];

            if (this.loadedPages.length >= 0) {
                let stop;

                this.loadedPages.forEach((item, i) => {
                    if (stop || !item) { return; }

                    if (index > item.length - 1) {
                        index = index - item.length;
                    } else {
                        itemPage = item[index];
                        stop = true;
                    }
                });
            }

            if (!_.isEmpty(itemPage)) {
                return itemPage;
            } else if (!page) {
                this.fetchMoreItems(pageNumber);
            }
        }

        /**
        * Gets processed item display name
        * @param {any} item
        */
        getItemDisplayName(item: any) {
            if (!item)
                return '';
            switch (item.saleLineType) {
                case SalesTypeEnum.PackageTransfer:
                    return ` ${this.$translate.instant('CUSTOM_LABEL_PACKAGE_TRANSFER')} - ${item.itemDisplayName }`;
                case SalesTypeEnum.Package:
                    return item.packageCreationType === Meevo.Model.PackageCreationTypeEnum.Custom
                        ? `${this.$translate.instant("LABEL_CUSTOM_PACKAHGE")} - ${item.packageNumber}`
                        : item.itemDisplayName;
                case SalesTypeEnum.GiftCard:
                case SalesTypeEnum.ReloadGiftCard:
                    const standartName = item.isEgift ? this.$translate.instant('LABEL_GIFT_CARD') : this.$translate.instant('LABEL_STANDARD_GIFT_CARD');
                    return Model.Guard.isSomething(item.itemDisplayName) ? item.itemDisplayName : standartName;
                case SalesTypeEnum.PackageServiceSwapFee:
                    return Model.Guard.isSomething(item.itemDisplayName) ? item.itemDisplayName : this.$translate.instant('LABEL_PACKAGE_SERVICE_SWAP');
                case SalesTypeEnum.EgiftProcessingFee:
                    return this.historyItemTypeDisplay[item.saleLineType];
                case SalesTypeEnum.EgiftShippingFee:
                    return this.historyItemTypeDisplay[item.saleLineType];
                case SalesTypeEnum.ClientAccountCredit:
                    return `${this.$translate.instant("LABEL_CLIENT_ACCOUNT_CREDIT_FOR")} ${item.displayName}`;
                case SalesTypeEnum.ClientAccountPayment:
                    return `${this.$translate.instant("LABEL_CLIENT_ACCOUNT_PAYMENT_FOR")} ${item.displayName}`;
                case SalesTypeEnum.DepositCredit:
                    return `${this.$translate.instant("LABEL_CLIENT_DEPOSIT_PAYMENT")}`;
                case SalesTypeEnum.PaymentPlanPayment:
                    return `${this.$translate.instant("LABEL_PAYMENT_PLAN_PAYMENT")}`;
                case SalesTypeEnum.PaymentPlanPaymentEFT:
                    return `${this.$translate.instant("LABEL_PAYMENT_PLAN_PAYMENT_EFT")}`;
                case SalesTypeEnum.PaymentPlanReduction:
                    return `${this.$translate.instant("LABEL_PAYMENT_PLAN_REDUCTION_REFUND_HEADER")}`;
                case SalesTypeEnum.AssociatedClient:
                    return `${this.$translate.instant("LABEL_TIP_ONLY")}`;
                default:
                    return item.itemDisplayName;
            }
        }

        /**
        * Gets employee display name
        * @param {any} item
        */
        getEmployeeDisplayName(item): void {
            let employeDisplayName = `${item.employeeCode ? item.employeeCode : ''}: ${item.employeeLastName}, ${item.employeeFirstName}`;
            return employeDisplayName ? employeDisplayName : item.userDisplayName;
        }

        getTeacherDisplayName(item): string {
            if (item.employeeEntityType !== Meevo.Model.EmployeeEntityTypeEnum.Student) {
                return '';
            }


            if (item.teacherFirstName) {
                return `${item.teacherCode ? item.teacherCode : ''}: ${item.teacherLastName}, ${item.teacherFirstName}`;
            } else {
                return 'LABEL_GENERIC_NOT_AVAILABLE';
            }
        }

        getPackageDisplayName(item): string{
            return item.packageCreationTypeEnum === Meevo.Model.PackageCreationTypeEnum.Custom
                ? this.$translate.instant('LABEL_CUSTOM_PACKAHGE')
               : item.displayName;
        }

        getHistoryItemTypeDisplay(item: any): string {
            const isEgiftcard = (item.saleLineType === SalesTypeEnum.GiftCard && item.isEgift) ||
                                (item.saleLineType === SalesTypeEnum.EgiftProcessingFee) ||
                                (item.saleLineType === SalesTypeEnum.EgiftShippingFee);
            return isEgiftcard ? this.$translate.instant('LABEL_E_GIFT_CARD') : this.$translate.instant(this.historyItemTypeDisplay[item.saleLineType]);
        }
        isTransactionTransfer(saleLineType: any): boolean {
            return saleLineType == SalesTypeEnum.PackageTransfer;
        }

        getTransactions(request, isLoadMore: boolean = false): void {
            let transactions, endpoint;

            if (this.selectedTab === TabViewEnum.ImportedView) {
                transactions = this.importedHistory;
                endpoint = this.importedHistSectionEndpoint;
            }
            else if (this.selectedTab === TabViewEnum.DiscountView) {
                transactions = this.discountHistory;
                endpoint = this.discountHistSectionEndpoint;
            }
            else /* if (this.selectedTab === TabViewEnum.TransactionView) */ {
                transactions = this.transactionHistory;
                endpoint = this.transactionHistSectionEndpoint;
            }

            request.pageNumber = isLoadMore ? this.currentHistoryPage + 1 : 0;  

            this.busyService.start();
            this.dataService.customMethodData(`api/client/${this.parentItemId}/${endpoint}/List/`, "POST", request).then((results: any) => {
                if (results.data.length > (request.itemsPerPage - 1)) {
                    if (this.extraItem != null && (request.pageNumber || 0) > 0) {
                        results.data.unshift(this.extraItem);
                    }
                    this.extraItem = results.data.pop();
                    this.next50Exist = true;
                } else {
                    if (this.extraItem != null) {
                        results.data.unshift(this.extraItem);
                    }
                    this.extraItem = null;
                    this.next50Exist = false;
                }

                this.postProcessTransactionData(results);

                if (isLoadMore) {
                    this.transactionsScrollTopElement = transactions.items.length;
                    transactions.items.push(...results.data);
                } else {
                    transactions.items = results.data;
                }
            }).finally(() => {
                this.busyService.stop();
                this.currentHistoryPage = request.pageNumber || 0;
                if (isLoadMore) {
                    setTimeout(() => this.scrollToPosition(isLoadMore), 500);         
                }
            });
        }

        postProcessTransactionData(results): void {
            if (this.selectedTab === TabViewEnum.DiscountView) {
                results.data.forEach((item: IClientDiscountHistory) => {
                    if (item.discountTypeEnum === DiscountTypeEnum.PercentOff) {
                        item['displayDiscountValue'] = item.discountValue * 100 + "%"
                    }
                })
            }
        }

        getMoreTransactions(request): void {
            this.getTransactions(request, true);
        }

        scrollToPosition(isLoadMore: boolean): void {
            
            if (this.currentlySelectedTab == ClientHistoryType.AccountActivity) {
                this.activityAttribute.topIndex = 0;
                this.topIndex = 0;
                console.log('.')
                return ;
            }
            let elem;
            if (isLoadMore) {
                elem = document.querySelector('.scroll-top-element-' + this.selectedTab);
            } else {
                elem = document.querySelector('.first-transaction-' + this.selectedTab);
            }
            if (elem) { elem.scrollIntoView() };
        }

        public meetsPrivateServiceMaskingCriteriaForAppointments(item: any) {
            return item.appointmentFinalState === Meevo.Model.AppointFinalStateEnum.CheckedOut
                || item.appointmentFinalState === Meevo.Model.AppointFinalStateEnum.Cancelled
                || item.appointmentTransitionState === Meevo.Model.AppointStateEnum.NoShow;
        }

        /*  end transaction history  */
        ///////////////////////////////////////
        /*  start giftCard history */


        /*  end giftCard history */

        getTotalServiceVisits(): void {
            let locationId = (this.request.criteria.locationId) ? this.request.criteria.locationId : 0;
            this.dataService.customMethodData(`api/client/${this.parentItemId}/totalVisitsAtLocation/${locationId}`, "GET", null)
                .then((response) => {
                    this.totalServiceVisits = response.data;
                });
        }

        private defaultAppointmentHistoryFilter: any = {
            sortDirection: Meevo.Model.SortDirection.Ascending,
            filterType: null,
            isGlobal: false
        };
        setAppointmentHistorySortDirection(sort, clientAppointmentHistoryFilterType) {
            if (clientAppointmentHistoryFilterType == 1) { /* Future */
                sort.sortDirection = Meevo.Model.SortDirection.Ascending;
            }
            else {
                sort.sortDirection = Meevo.Model.SortDirection.Descending;
            }
            this.defaultAppointmentHistoryFilter.filterType = clientAppointmentHistoryFilterType;
            this.defaultAppointmentHistoryFilter.sortDirection = sort.sortDirection;
        }

        ahGlobalChecked(isGlobal) {
            this.defaultAppointmentHistoryFilter.isGlobal = isGlobal;
        }

        /**
        * Open selected paymentPlanId in Payment Plan Manager
        * @param {string} paymentPlanId
        */
        openPaymentPlanManager(paymentPlanId: string): void {
            if (!paymentPlanId) return;

            let targetRoute = `${this.appSettings.ROUTE_NAMES.paymentPlans}/${paymentPlanId}/main`;

            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.paymentPlans,
                stateParams: {
                    targetRoute
                }
            });
        }

        showInsufficientBalanceLabel(saleLine: any) {
            return saleLine.saleLineType === Model.SalesTypeEnum.DepositCredit && saleLine.isRefund && saleLine.totalPrice === 0;
        }

        public filterDescription: any[] = [];
        getFilterDescription(): any[] {
           
          let filterDesc: any[] = [];
            let locationName: string, startDate: string, endDate: string, itemTypeDesc: string;
            let dateFilter: any = this.$filter('meevoDateFilter');
            let dateRange: any;

            switch (this.currentlySelectedTab) {
                case ClientHistoryType.AccountActivity:
                    startDate = (this.defaultAccountActivityCriteria && this.defaultAccountActivityCriteria.StartDateTime)
                        ? dateFilter(this.defaultAccountActivityCriteria.StartDateTime)
                        : "";
                    endDate = (this.defaultAccountActivityCriteria && this.defaultAccountActivityCriteria.EndDateTime)
                        ? dateFilter(this.defaultAccountActivityCriteria.EndDateTime)
                        : "";
                    dateRange = (this.context && this.context.selectedPreset)
                        ? this.context.selectedPreset.name
                        : "";
                    dateRange = this.$translate.instant(dateRange)

                    
                    locationName = (this.locations && this.locations.length > 1 && !this.hideLocations)
                        ? ( (this.defaultAccountActivityCriteria && this.defaultAccountActivityCriteria.LocationId)
                            ? this.locations.find((v, i, a) => v.locationId == this.defaultAccountActivityCriteria.LocationId).storeName
                            : this.$translate.instant("LABEL_ALL"))
                        : "";

                    if (this.defaultAccountActivityCriteria) {
                        switch (this.defaultAccountActivityCriteria.ItemType) {
                            case AccountHistoryItemType.Payment:
                                itemTypeDesc = this.$translate.instant("LABEL_PAYMENT");
                                break;
                            case AccountHistoryItemType.Credit:
                                itemTypeDesc = this.$translate.instant("LABEL_CREDIT");
                                break;
                            case AccountHistoryItemType.DepositPayment:
                                itemTypeDesc = this.$translate.instant("LABEL_CLIENT_DEPOSIT_PAYMENT");
                                break;
                            case AccountHistoryItemType.DepositCharge:
                                itemTypeDesc = this.$translate.instant("LABEL_CLIENT_DEPOSIT_CHARGE");
                                break;
                            case AccountHistoryItemType.Charge:
                                itemTypeDesc = this.$translate.instant("LABEL_CLIENT_ACCOUNT_PAYMENT");
                                break;
                            default:
                                itemTypeDesc = this.$translate.instant("LABEL_ALL");
                                break;
                        }
                    }

                    filterDesc.push({ label: 'LABEL_DATE_RANGE', value: `${dateRange}` })
                    filterDesc.push({ label: 'LABEL_ITEM_TYPE', value: itemTypeDesc });
                    if (!this.isSingleLocation()) {
                        filterDesc.push({ label: 'LABEL_LOCATION', value: locationName });
                    }
                    filterDesc.push({ label: 'LABEL_START_DATE', value: `${startDate}` });
                    filterDesc.push({ label: 'LABEL_END_DATE', value: `${endDate}` });
                    break;

                case ClientHistoryType.AppointmentHistory:
                    if (!this.isSingleLocation() && this.viewGlobalFilter) {
                        filterDesc.push({ label: 'LABEL_GLOBAL', value: this.defaultAppointmentHistoryFilter.isGlobal ? "Checked" : "Not Checked" });
                    }
                    let ahFilter: string;
                    switch (this.defaultAppointmentHistoryFilter.filterType) {
                        case ClientAppointmentHistoryFilterType.Future:
                            ahFilter = this.$translate.instant("LABEL_FUTURE");
                            break;
                        case ClientAppointmentHistoryFilterType.Cancelled:
                            ahFilter = this.$translate.instant("LABEL_CANCELLED");
                            break;
                        case ClientAppointmentHistoryFilterType.CheckedOut:
                            ahFilter = this.$translate.instant("LABEL_CHECKED_OUT");
                            break;
                        case ClientAppointmentHistoryFilterType.NoShow:
                            ahFilter = this.$translate.instant("LABEL_NO_SHOW");
                            break;
                        case ClientAppointmentHistoryFilterType.NoShowAndCancelled:
                            ahFilter = this.$translate.instant("LABEL_NO_SHOW_AND_CANCELLED");
                            break;
                        case ClientAppointmentHistoryFilterType.All:
                        default:
                            ahFilter = this.$translate.instant("LABEL_ALL");
                            break;
                    }
                    filterDesc.push({ label: 'LABEL_SHOW', value: ahFilter });
                    break;

                case ClientHistoryType.GiftCardHistory:
                    locationName = (this.locations && this.locations.length > 1 && !this.hideLocations)
                        ? (this.request.criteria.locationId
                            ? this.locations.find((v, i, a) => v.locationId == this.request.criteria.locationId).storeName
                            : this.$translate.instant("LABEL_ALL"))
                        : "";
                    if (!this.isSingleLocation()) {
                        filterDesc.push({ label: 'LABEL_LOCATION', value: locationName });
                    }
                    let gcFilter: string;
                    switch (this.defaultGiftCardCriteria.filter) {
                        case "1":
                            gcFilter = this.$translate.instant("LABEL_ACTIVE");
                            break;
                        case "2":
                            gcFilter = this.$translate.instant("LABEL_NO_BALANCE");
                            break;
                        case "3":
                            gcFilter = this.$translate.instant("LABEL_EXPIRED");
                            break;
                        case "0":
                        default:
                            gcFilter = this.$translate.instant("LABEL_ALL");
                            break;
                    }
                    filterDesc.push({ label: 'LABEL_SHOW', value: gcFilter });
                    break;

                case ClientHistoryType.PackageHistory:
                    locationName = (this.locations && this.locations.length > 1 && !this.hideLocations)
                        ? (this.request.criteria.locationId
                            ? this.locations.find((v, i, a) => v.locationId == this.request.criteria.locationId).storeName
                            : this.$translate.instant("LABEL_ALL"))
                        : "";
                    if (!this.isSingleLocation()) {
                        filterDesc.push({ label: 'LABEL_LOCATION', value: locationName });
                    }
                    filterDesc.push({ label: 'LABEL_SHOW', value: `${this.$translate.instant(this.packageTypeList.find((v, i, a) => v.value == this.packagesFilter).label)}` });
                    break;

                case ClientHistoryType.TransactionHistory:
                    startDate = (this.request && this.request.criteria && this.request.criteria.startDate)
                        ? dateFilter(this.request.criteria.startDate)
                        : "";
                    endDate = (this.request && this.request.criteria && this.request.criteria.endDate)
                        ? dateFilter(this.request.criteria.endDate)
                        : "";
                    dateRange = (this.context && this.context.selectedPreset)
                        ? this.context.selectedPreset.name
                        : "";
                    dateRange = this.$translate.instant(dateRange)
                    locationName = (this.locations && this.locations.length > 1 && !this.hideLocations)
                        ? (this.request.criteria.locationId
                            ? this.locations.find((v, i, a) => v.locationId == this.request.criteria.locationId).storeName
                            : this.$translate.instant("LABEL_ALL"))
                        : this.$translate.instant("LABEL_ALL");
                    itemTypeDesc = (this.request && this.request.criteria && this.request.criteria.saleTypeFilterEnum)
                        ? this.$translate.instant(this.itemTypes.find((v, i, a) => v.saleTypeFilterEnum == this.request.criteria.saleTypeFilterEnum).label)
                        : this.$translate.instant("LABEL_ALL");

                    filterDesc.push({ label: 'LABEL_DATE_RANGE', value: `${dateRange}` })
                    filterDesc.push({ label: 'LABEL_ITEM_TYPE', value: itemTypeDesc });
                    if (!this.isSingleLocation()) {
                        filterDesc.push({ label: 'LABEL_LOCATION', value: locationName });
                    }
                    filterDesc.push({ label: 'LABEL_START_DATE', value: `${startDate}` });
                    filterDesc.push({ label: 'LABEL_END_DATE', value: `${endDate}` });
                    break;

                default:
                    filterDesc.push({ label: 'LABEL_FILTERS', value: '' });
                    break;
            }            
            return filterDesc;
        }

        getHistoryResultsTop(): number {
            let top: number;
            if (this.$scope.isMobileDevice && this.hideMobileFilters) {
                top = 20;
            }
            else {
                top = (this.isFilterExpanded) ? 265 : 200;
                if (this.firstVisitDate) {
                    top += 20;
                }
                if (this.lastVisitDate) {
                    top += 20;
                }
            }
            return top;
        }

        getPackageHistoryResultsTop(): number {
            let top: number;
            if (this.$scope.isMobileDevice && this.hideMobileFilters) {
                top = 20;
            }
            else {
                top = (this.isFilterExpanded) ? 175 : 130;
            }
            return top;
        }

        getGiftCardCardItemSize(isMobileDevice): number {
            return isMobileDevice ? 196 : 125;
        }

        public defaultGiftCardCriteria: any = {
            isGlobal: false
        };
        getDefaultGiftCardCriteria() {
            this.defaultGiftCardCriteria = {
                isGlobal: false,
                filter: Meevo.Plugins.Client.ClientAppointmentHistoryFilterType.All.toString(),
            };
            if (!!this.historyFilter) {
                this.defaultGiftCardCriteria.filter = this.historyFilter;
            }
            return this.defaultGiftCardCriteria;
        }

        gcFiltered() {
            this.filterDescription.length = 0;
            this.filterDescription.push(...this.getFilterDescription());
            this.isFilterExpanded = false;
        }

        selectGcLocation(locationId: number) {
            this.request.criteria.locationId = locationId;
        }

        selectGcFilter(filter) {
            this.defaultGiftCardCriteria.filter = filter;
        }

        ahFiltered() {
            this.filterDescription.length = 0;
            this.filterDescription.push(...this.getFilterDescription());
            this.isFilterExpanded = false;
        }

        public defaultAccountActivityCriteria: IAccountHistoryCriteria ;
        onAccountActivityFiltered(criteria: IAccountHistoryCriteria) {
            this.defaultAccountActivityCriteria = { ...criteria };
            this.filterDescription.length = 0;
            this.filterDescription.push(...this.getFilterDescription());
        }
    }
}
